import { useState } from 'react';
import Catalog from './catalog';
import { ViewMode } from './catalog-wrapper';
import { useSearchParams } from 'react-router-dom';

function NewIekSearch() {
    const [params] = useSearchParams();
    const [viewMode, setViewMode] = useState(ViewMode.List);
    return (
        <div className={'catalog-content' + (viewMode === ViewMode.List ? ' catalog-content--list' : '')}>
            <Catalog key={params.get('q')} viewMode={viewMode} setViewMode={setViewMode} globalMode />
        </div>
    );
}

export default NewIekSearch;
